import HelpIcon from "@mui/icons-material/Help";
import AppBar from "@mui/material/AppBar";
import Avatar from "@mui/material/Avatar";
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import LibraryBooksOutlinedIcon from "@mui/icons-material/LibraryBooksOutlined";
import LogoutIcon from "@mui/icons-material/Logout";
import { IconButton, ListItemIcon, Menu, MenuItem } from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./header.css";

import dexcom_logo from "../../assets/dexcom-logo.png";
import { auth } from "../../auth/firebase-config";
import PDFViewer from "../chatpage/pdf-viewer-iframe";
import {
  Sheet,
  SheetContent,
  SheetDescription,
  SheetHeader,
  SheetTitle,
  SheetTrigger,
} from "../ui/sheet";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "../ui/tooltip";
import SessionTimeoutHandler from "@/components/login/session-timeout-handler";

const UserMenu = ({
  handleCloseUserMenu,
  isMenuOpen,
  userInfo,
  userRoles,
}: any) => {
  const navigate = useNavigate();

  const user = {
    name: userInfo[0],

    email: userInfo[1],
    img: userInfo[2],
  };

  const handleManageKnowledgeBase = () => {
    navigate("/knowledgebase");
    handleCloseUserMenu();
  };

  const handlelogout = () => {
    auth.signOut();
    localStorage.removeItem("userInfo");
    localStorage.removeItem("accessToken");
    localStorage.removeItem("user_data");
    handleCloseUserMenu();
    navigate("/login");
  };

  return (
    <Box sx={{ mr: "40px" }}>
      <Menu
        id="menu-appbar"
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        open={isMenuOpen}
        onClose={handleCloseUserMenu}
        PaperProps={{
          sx: {
            width: "255px",
            m: 7,
            ml: -2,
          },
        }}
      >
        <Box display="flex" flexDirection="column" alignItems="center" p={1.3}>
          <Avatar
            src={user.img}
            alt={user.name}
            sx={{ width: 55, height: 55, mb: 1 }}
          />
          <Typography variant="h6" sx={{ fontWeight: "bold" }}>
            {user.name}
          </Typography>
          <Typography variant="body2" color="textSecondary">
            {user.email}
          </Typography>
        </Box>
        <Divider />
        {userRoles?.includes("admin") && (
          <MenuItem sx={{ m: 1 }} onClick={handleManageKnowledgeBase}>
            <ListItemIcon>
              <LibraryBooksOutlinedIcon />
            </ListItemIcon>
            <Typography fontWeight="600" variant="inherit">
              Manage Knowledge Base
            </Typography>
          </MenuItem>
        )}
        <Divider />
        <MenuItem
          sx={{ m: 1 }}
          onClick={() => {
            handlelogout();
          }}
        >
          <ListItemIcon>
            <LogoutIcon />
          </ListItemIcon>
          <Typography fontWeight="600" variant="inherit">
            Logout
          </Typography>
        </MenuItem>
        <Divider />
      </Menu>
    </Box>
  );
};

export default function Header({
  gcsPath = "gs://dxcm_user_guide/DexcomPhase 2 __ User Guide For Generate New Document.pdf",
}) {
  const navigate = useNavigate();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const handleOpenUserMenu = () => setIsMenuOpen(true);
  const handleCloseUserMenu = () => setIsMenuOpen(false);

  const [userInfo, setUserInfo] = useState(null);
  const [name, setname] = useState("");
  const [email, setemail] = useState("");
  const [profileimg, setprofileimg] = useState("");
  const [roles, setRoles] = useState([]);

  useEffect(() => {
    const storedUserInfo = localStorage.getItem("userInfo");
    if (storedUserInfo) {
      const uinfo = JSON.parse(storedUserInfo);
      setname(uinfo.name);
      setemail(uinfo.email);
      setprofileimg(uinfo.profileImage);

      setUserInfo(JSON.parse(storedUserInfo));
    }
    const userData = localStorage.getItem("user_data");
    if (userData) {
      const parsedUserData = JSON.parse(userData);
      setRoles(parsedUserData.roles);
    }
  }, []);

  return (
    <>
      <SessionTimeoutHandler />
      <Box>
        <AppBar position="static" color="transparent" className="app-bar">
          <Toolbar>
            <img
              src={dexcom_logo}
              alt="logo"
              className="logo"
              onClick={() => navigate("/dashboard")}
              style={{ cursor: "pointer" }}
            />
            <Box className="flex-grow" />
            <IconButton sx={{ margin: "0 0.5rem 0 0" }}>
              <TooltipProvider>
                <Tooltip>
                  <TooltipTrigger>
                    <Sheet>
                      <SheetTrigger>
                        <HelpIcon />
                      </SheetTrigger>
                      <SheetContent style={{ maxWidth: "50vw" }}>
                        <SheetHeader>
                          <SheetTitle>User Guide</SheetTitle>
                          <SheetDescription>
                            <div className="font-semibold"></div>
                            <PDFViewer gcsPath={gcsPath} />
                          </SheetDescription>
                        </SheetHeader>
                      </SheetContent>
                    </Sheet>
                  </TooltipTrigger>
                  <TooltipContent className="bg-black">
                    <p className="text-white">View User Guide</p>
                  </TooltipContent>
                </Tooltip>
              </TooltipProvider>
            </IconButton>
            {/* Profile Section */}
            <Box className="profile-section">
              <Divider
                orientation="vertical"
                sx={{ height: "40px" }}
                variant="middle"
                flexItem
              />

              {/* Profile Image and Name */}
              <Box
                onClick={handleOpenUserMenu}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  cursor: "pointer",
                }}
              >
                <Avatar
                  src={profileimg}
                  alt={name}
                  sx={{
                    width: "32px",
                    height: "32px",
                    mx: 1,
                    cursor: "pointer",
                  }}
                />

                <Typography
                  variant="h4"
                  component="div"
                  sx={{ fontWeight: "bold" }}
                >
                  {name}
                </Typography>
              </Box>
            </Box>
          </Toolbar>
        </AppBar>
      </Box>
      <UserMenu
        handleCloseUserMenu={handleCloseUserMenu}
        isMenuOpen={isMenuOpen}
        userInfo={[name, email, profileimg]}
        userRoles={roles}
      />
    </>
  );
}
